import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Home, Menu } from "lucide-react";
import { useDirtyNavigate } from "../../context/DirtyGuard";
import { LangToggle } from "../controls/Toggles";
import { NavDrawer } from "./NavDrawer";

// شريط عنوان ثابت لكل صفحة: العنوان + زر الرئيسية (نص) + زر القائمة (hamburger يفتح درج التبويبات) + اللغة.
export const PageTitleBar = ({ title, subtitle, titleClassName }) => {
  const go = useDirtyNavigate();
  const { t } = useTranslation();
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <div
      data-testid="page-title-bar"
      className="page-title-bar pointer-events-none fixed inset-x-0 top-0 z-40 bg-gradient-to-b from-background via-background/90 to-transparent pb-5 pt-[max(0.75rem,env(safe-area-inset-top))] backdrop-blur-xl"
    >
      <div className="pointer-events-auto mx-auto flex w-full items-start gap-3 px-4 sm:px-8 lg:px-12 2xl:px-16">
        <div className="min-w-0 flex-1">
          <h1 className={`truncate font-black tracking-tight ${titleClassName || "text-2xl sm:text-3xl"}`} data-testid="page-title">
            {title}
          </h1>
          {subtitle ? (
            <p className="mt-0.5 truncate text-xs text-muted-foreground" data-testid="page-subtitle">
              {subtitle}
            </p>
          ) : null}
        </div>
        <button
          type="button"
          data-testid="page-home-btn"
          onClick={() => go("/")}
          className="hidden h-11 shrink-0 items-center gap-2 rounded-2xl border border-border/70 bg-background px-4 text-sm font-bold text-muted-foreground shadow-neu-sm transition-colors hover:text-primary lg:inline-flex"
        >
          <Home className="h-4 w-4" />
          {t("nav.home")}
        </button>
        <button
          type="button"
          title={t("nav.menu")}
          data-testid="page-menu-btn"
          onClick={() => setMenuOpen(true)}
          className="hidden h-11 w-11 shrink-0 place-items-center rounded-2xl border border-border/70 bg-background text-muted-foreground shadow-neu-sm transition-colors hover:text-primary lg:grid"
        >
          <Menu className="h-5 w-5" />
        </button>
        <LangToggle />
      </div>
      <NavDrawer open={menuOpen} onClose={() => setMenuOpen(false)} />
    </div>
  );
};
